import React from 'react'
import { CheckCircle } from '@mui/icons-material'
import type { UserOwnerVerification } from 'src/utils/mapUserListRows'
import { size } from 'src/variable/constant'

const CHANNEL_LABELS: Record<string, string> = {
	whatsapp: 'WhatsApp',
	zalo: 'Zalo',
}

export const ownerChannelLabel = (channel?: string | null) => {
	const key = String(channel ?? '').trim().toLowerCase()
	return CHANNEL_LABELS[key] || String(channel ?? '').trim()
}

interface OwnerConfirmedCellProps {
	value?: UserOwnerVerification | null
}

// Users list cell: who confirmed the phone owner, or a dash when nobody did
function OwnerConfirmedCell({ value }: OwnerConfirmedCellProps) {
	if (!value || typeof value !== 'object') {
		return <div>-</div>
	}

	const detail = [value.verified_by_name, value.verified_at].filter(Boolean).join(', ')

	return (
		<div style={{ maxWidth: size.text }}>
			<div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
				<CheckCircle color="success" fontSize="small" titleAccess="Owner confirmed" />
				<span>{ownerChannelLabel(value.channel)}</span>
			</div>
			{detail && (
				<div
					style={{ fontSize: 12, color: '#666', overflow: 'hidden', textOverflow: 'ellipsis' }}
					title={detail}
				>
					{detail}
				</div>
			)}
		</div>
	)
}

export default React.memo(OwnerConfirmedCell)
